import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 1599350F-AA11-47A2-8D1C-B60DF1A0A5AD
 * name gender-male-female-variant
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gender-male-female-variant.svg
 * tags
 */
export const GenderMaleFemaleVariantIcon = createSvgIcon(<><path d="M7 3A5 5 0 0 0 9 7A5 5 0 0 0 7 11A5 5 0 0 0 11 15.9V18H9V20H11V22H13V20H15V18H13V15.9A5 5 0 0 0 17 11A5 5 0 0 0 15 7A5 5 0 0 0 17 3H15A3 3 0 0 1 12 6A3 3 0 0 1 9 3M12 8A3 3 0 0 1 15 11A3 3 0 0 1 12 14A3 3 0 0 1 9 11A3 3 0 0 1 12 8Z" /></>, 'GenderMaleFemaleVariantIcon');
export default GenderMaleFemaleVariantIcon